import { c as _c } from "react/compiler-runtime";
import { format } from "date-fns";
import { Sparkle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import Image from "next/image";
interface EmptyStateProps {
  selectedDate: Date;
  focusInput: () => void;
}
export function EmptyState(t0) {
  const $ = _c(12);
  const {
    selectedDate,
    focusInput
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative mb-6"><div className="w-16 h-16 rounded-full bg-muted/50 border border-border flex items-center justify-center overflow-hidden"><Image src="/vif-icon.png" alt="Vif" width={128} height={128} className="size-10 object-contain" priority={true} unoptimized={true} /></div></div>;
    t2 = <h3 className="text-lg font-medium text-foreground mb-1.5">Vif is all clear!</h3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== selectedDate) {
    t3 = format(selectedDate, "EEEE");
    $[2] = selectedDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <p className="text-sm text-muted-foreground text-center max-w-[260px]">Your {t3} is looking empty. Add your first task to get started with Vif!</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Sparkle className="w-4 h-4 mr-2" weight="fill" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== focusInput) {
    t6 = <Button variant="outline" size="sm" className="mt-6 text-sm font-normal" onClick={focusInput}>{t5}Send action</Button>;
    $[7] = focusInput;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="flex flex-col items-center justify-center h-[50vh] px-4">{t1}{t2}{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}